'use strict';
var pageRefresh = sessionStorage.getItem('pageHasBeenLoaded');
    if (pageRefresh) {
      //console.log('this is a reload');
      setTimeout(function () {
        const myitems = document.querySelector(".section-yt");
        if (myitems) {
          var evt = new Event("resize", { "bubbles": true, "cancelable": false });
          myitems.dispatchEvent(evt);
        }        
      }, 5000);
      clearTimeout();
    }
sessionStorage.setItem('pageHasBeenLoaded', 'true');
    
/* hover on ios */
(function (l) {
  var i,
    s = { touchend: function () {} };
  for (i in s) l.addEventListener(i, s);
})(document);

window.addEventListener('resize', function () { 
  removePreviewBar();
  if (document.getElementById('artist-splitheader')) {
      adjustTopPosition('artist-splitheader');
  }  
});

function checkSafari() {
  var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
  var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
  var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
  var is_safari = navigator.userAgent.indexOf('Safari') > -1;
  var is_opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
  if (is_chrome && is_safari) {
    is_safari = false;
  }
  if (is_chrome && is_opera) {
    is_chrome = false;
  }

  if (
    navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1
  ) {
    return true;
  } else {
    return false;
  }
}
/* trigger touch on ios safari */
function touchTrigger() {
  if (checkSafari()) {
    var el = document.getElementById('quickView');
    // desktop
    //el.click();

    // mobile
    if (window.matchMedia('(max-width: 768px)').matches) {
      //alert('touch');
      var event1 = new Event('touchstart');
      var event2 = new Event('touchend');
      el.dispatchEvent(event1);
      el.dispatchEvent(event2);
    }
  }
}

/* update document meta on ios safari, to prevent scaling */
function updateMetaIos() {
  if (checkSafari()) {
    // mobile
    if (window.matchMedia('(max-width: 768px)').matches) {
      var isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (isIOS) {
        const metaEl = document.querySelector('meta[name="viewport"');
        if (metaEl) {
          //alert('update meta');
          metaEl.setAttribute(
            'content',
            'width=device-width,initial-scale=1,shrink-to-fit=no,user-scalable=no'
          );
        }
      }
    }
  }
}

function checkMobileIos() {
  if (checkSafari()) {
    // mobile
    if (window.matchMedia('(max-width: 768px)').matches) {
      var isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (isIOS) {
          alert('IOS mobile');
      }
    }
  }
}


function checkModalScrollable() {
  const isScrollable = function (ele) {
    // Compare the height to see if the element has scrollable content
    const hasScrollableContent = ele.scrollHeight > ele.clientHeight;

    // It's not enough because the element's `overflow-y` style can be set as
    // * `hidden`
    // * `hidden !important`
    // In those cases, the scrollbar isn't shown
    const overflowYStyle = window.getComputedStyle(ele).overflowY;
    const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

    return hasScrollableContent && !isOverflowHidden;
  };
  const thePrdModal = document.querySelector('.modal-body');
  const theAtcModal = document.querySelector('#addToCartForm');
  if (isScrollable(thePrdModal)) {
    //console.log("scrollable");
  } else {
    //console.log("Non scrollable, remove touch");
    //thePrdModal.classList.add('modal-no-touch');
    //theAtcModal.classList.add('modal-no-touch');
  }
}

function disableDocumentScrolling() {
  if (document.documentElement.style.position != 'fixed') {
    // Get the top vertical offset.
    var topVerticalOffset =
      typeof window.pageYOffset != 'undefined'
        ? window.pageYOffset
        : document.documentElement.scrollTop
        ? document.documentElement.scrollTop
        : 0;
    // Set the document to fixed position (this is the only way around IOS' overscroll "feature").
    document.documentElement.style.position = 'fixed';
    // Set back the offset position by user negative margin on the fixed document.
    document.documentElement.style.marginTop = '-' + topVerticalOffset + 'px';
  }
}

function enableDocumentScrolling() {
  if (document.documentElement.style.position == 'fixed') {
    // Remove the fixed position on the document.
    document.documentElement.style.position = null;
    // Calculate back the original position of the non-fixed document.
    var scrollPosition =
      -1 * parseFloat(document.documentElement.style.marginTop);
    // Remove fixed document negative margin.
    document.documentElement.style.marginTop = null;
    // Scroll to the original position of the non-fixed document.
    window.scrollTo(0, scrollPosition);
  }
}

function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

/* sticky behavior of navigation bar on page scroll */
const stickyNavbar = (() => {
  let navbar = document.querySelector('.navbar-sticky');

  if (navbar == null) return;

  let navbarClass = navbar.classList,
    navbarH = navbar.offsetHeight,
    scrollOffset = 500;

  window.addEventListener('scroll', e => {
    if (navbar.classList.contains('position-absolute')) {
      if (e.currentTarget.pageYOffset > scrollOffset) {
        navbar.classList.add('fixed-top');
        navbar.classList.add('bg-navcust');
        //navbar.classList.add('svg-icon-change');
      } else {
        navbar.classList.remove('fixed-top');
        //navbar.classList.remove('svg-icon-change');
      }
    } else {
      if (e.currentTarget.pageYOffset > scrollOffset) {
        document.body.style.paddingTop = navbarH + 'px';
        navbar.classList.add('fixed-top');
        navbar.classList.add('bg-navcust');
      } else {
        document.body.style.paddingTop = '';
        navbar.classList.remove('fixed-top');
        //navbar.classList.remove('svg-icon-change');
      }
    }
  });
})();

/* remove empty element */
function CleanChildren(elem) {
  var children = elem.childNodes;
  var len = elem.childNodes.length;
  console.log(children);
  
  children.forEach(function (item) { 
    console.log(item.childNodes.length);
    if(item.childNodes.length == 0) item.remove(); 
  })
}

/* scroll to top */
var scrollTopButton = (function () {
  var element = document.querySelector('.btn-scroll-top'),
    scrollOffset = 600;
  if (element == null) return;
  var offsetFromTop = parseInt(scrollOffset, 10);
  window.addEventListener('scroll', function (e) {
    if (e.currentTarget.pageYOffset > offsetFromTop) {
      element.classList.add('show');
    } else {
      element.classList.remove('show');
    }
  });
})();

/* For Lang-select*/
var localeItems = document.querySelectorAll('#localeItem');
if (localeItems.length > 0) {
  localeItems.forEach(item => {
    item.addEventListener('click', event => {
      document.getElementById('localeCode').value = item.getAttribute('lang');
      document.getElementById('localization_form_tag').submit();
    });
  });
}

/* aos with lazyload fix*/
document
  .querySelectorAll('img')
  .forEach(img => img.addEventListener('load', () => AOS.refresh()));

function removePreviewBar() {
  // Remove #preview-bar-iframe
  window.setTimeout(() => {
    let previewBar = document.getElementById('preview-bar-iframe');
    if (previewBar) {
      previewBar.style['display'] = 'none';
      document.documentElement.removeAttribute('style');
    }
  }, 2000);
}


//sort
if (document.getElementById('sort_by') != null) {
  document.querySelector('#sort_by').addEventListener('change', function (e) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.currentTarget.value);
    window.location = url.href;
  });
}

/**
 * Range slider
 * @requires https://github.com/leongersen/noUiSlider
 */

var rangeSlider = (function () {
  var rangeSliderWidget = document.querySelectorAll('.range-slider');

  var _loop7 = function _loop7(i) {
    var rangeSlider = rangeSliderWidget[i].querySelector('.range-slider-ui'),
      valueMinInput = rangeSliderWidget[i].querySelector(
        '.range-slider-value-min'
      ),
      valueMaxInput = rangeSliderWidget[i].querySelector(
        '.range-slider-value-max'
      );
    var options = {
      dataStartMin: parseInt(rangeSliderWidget[i].dataset.startMin, 10),
      dataStartMax: parseInt(rangeSliderWidget[i].dataset.startMax, 10),
      dataMin: parseInt(rangeSliderWidget[i].dataset.min, 10),
      dataMax: parseInt(rangeSliderWidget[i].dataset.max, 10),
      dataStep: parseInt(rangeSliderWidget[i].dataset.step, 10),
    };
    var dataCurrency = rangeSliderWidget[i].dataset.currency;
    noUiSlider.create(rangeSlider, {
      start: [options.dataStartMin, options.dataStartMax],
      connect: true,
      step: options.dataStep,
      pips: {
        mode: 'count',
        values: 5,
      },
      tooltips: [
        true,
        {
          to: function to(value) {
            return ''.concat(dataCurrency ? dataCurrency : '$').concat(
              parseInt(value / 1000, 10)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              'K'
            );
          },
          from: function from(value) {
            return Number(value);
          },
        },
      ],
      range: {
        min: options.dataMin,
        max: options.dataMax,
      },
      format: {
        to: function to(value) {
          return ''
            .concat(dataCurrency ? dataCurrency : '$')
            .concat(parseInt(value, 10));
        },
        from: function from(value) {
          return Number(value);
        },
      },
    });
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      var value = values[handle];
      value = value.replace(/\D/g, '');

      if (handle) {
        valueMaxInput.value = Math.round(value);
      } else {
        valueMinInput.value = Math.round(value);
      }
    });
    valueMinInput.addEventListener('change', function () {
      rangeSlider.noUiSlider.set([this.value, null]);
    });
    valueMaxInput.addEventListener('change', function () {
      rangeSlider.noUiSlider.set([null, this.value]);
    });
  };

  for (var i = 0; i < rangeSliderWidget.length; i++) {
    _loop7(i);
  }
})();
/**
 * Filter list of items by typing in the search field
 */

var filterList = (function () {
  var filterListWidget = document.querySelectorAll('.widget-filter');

  var _loop8 = function _loop8(i) {
    var filterInput = filterListWidget[i].querySelector(
        '.widget-filter-search'
      ),
      filterList = filterListWidget[i].querySelector('.widget-filter-list'),
      filterItems = filterList.querySelectorAll('.widget-filter-item');

    if (!filterInput) {
      return 'continue';
    }

    filterInput.addEventListener('keyup', filterListFunc);

    function filterListFunc() {
      var filterValue = filterInput.value.toLowerCase();

      for (var _i4 = 0; _i4 < filterItems.length; _i4++) {
        var filterText = filterItems[_i4].querySelector(
          '.widget-filter-item-text'
        ).innerHTML;

        if (filterText.toLowerCase().indexOf(filterValue) > -1) {
          filterItems[_i4].classList.remove('d-none');
        } else {
          filterItems[_i4].classList.add('d-none');
        }
      }
    }
  };

  for (var i = 0; i < filterListWidget.length; i++) {
    var _ret2 = _loop8(i);

    if (_ret2 === 'continue') continue;
  }
})();

function truncate(str, max = 10) {
  const array = str.trim().split(' ');
  const ellipsis = array.length > max ? '...' : '';

  return array.slice(0, max).join(' ') + ellipsis;
}



// Product POP UP MODAL (prdquickview)
function getProductAnchors(prdId) {
  //console.log(prdId);

  const prdID = document.getElementById(`${prdId}`) || false;
  if (!prdID) {
    return;
  }
    var productInfoAnchors = document.querySelectorAll(`#${prdId}`);

    if (productInfoAnchors.length > 0) {
      //console.log(`Length ${prdId} ${productInfoAnchors.length}`);

      productInfoAnchors.forEach(item => {
        //console.log(item);
        item.addEventListener('click', event => {
          //console.log('Clicked');
          event.stopImmediatePropagation();

          var url = '/products/' + item.getAttribute('product-handle') + '.js';

          fetch(url)
            .then(resp => resp.json())
            .then(function (data) {
              //console.log(data);

              const modalSelectElement =
                document.getElementById('modalItemID') || false;

              if (modalSelectElement) {
                modalSelectElement.addEventListener('click', e =>
                  varModalSelectChange(e, data)
                );
                modalSelectElement.addEventListener('change', e =>
                  varModalSelectChange(e, data)
                );
                modalSelectElement.addEventListener('focus', e =>
                  varModalSelectChange(e, data)
                );
              }

              let productDescArr = data.description.split('$$$$$$');
              let productDesc;
              if (productDescArr.length > 1) {
                productDesc = productDescArr[0];
              } else {
                productDesc = truncate(productDescArr[0], 25);
              }
              let prdBadge = ``;
              let finalsaletag = '';

              if (data.tags.includes('Final Sale')) {
                finalsaletag = ` - FINAL SALE*`;
              }

              let addToWishlist = document.querySelectorAll('button-wishlist') || [];
              if (addToWishlist.length > 0) {
                //addToWishlist.setAttribute('data-product-handle',data.handle)
                //console.log(addToWishlist);
              }

              const shopUrl = Shopify.shop;
              //console.log(shopUrl);
              let prdPermalink = shopUrl + data.url;
              //href = "//www.facebook.com/sharer.php?u={{ permalinkURL }}"
              //href = "//twitter.com/share?url={{ permalinkURL }}"
              let fbShare = document.getElementById('share_fb') || false;
              let twitShare = document.getElementById('share_twit') || false;
              if (fbShare) {
                fbShare.setAttribute('href', "//www.facebook.com/sharer.php?u=" + prdPermalink);
              }
              if (twitShare) {
                twitShare.setAttribute('href', "//twitter.com/share?url=" + prdPermalink);
              }

              let prdType = document.getElementById('prdType') || false;
              if (data.type) {
                if (prdType) {
                  let typeHandle = data.type.replace(/ /g, '+');
                  prdType.innerHTML += "<a href='https://"+ shopUrl + "/collections/all/?filter.p.product_type=" + typeHandle + "'>" + data.type + "</a>";                    
                    
                }
              }

            
              let productTags = item.getAttribute('product-tags');
              if (productTags) {
                const arrproductTags = productTags.split(',');
                let prdTags = document.getElementById('prdTags') || false;
                if (data.tags.length > 0) {
                  if (prdTags) {
                    data.tags.forEach(
                      function (item, index) {
                        let tagHandle = item.toLowerCase().replace(/ /g, '-');
                        if (arrproductTags.includes(item)) {
                          prdTags.innerHTML += "<a href='https://"+ shopUrl + "/collections/all/" + tagHandle + "'>" + item + "</a>" + (data.tags.length > 0 && +index < data.tags.length - 1 && +index < arrproductTags.length ? ", " : "");
                        }                        
                      }
                    )
                  }
                }
              }  
              
              let prd_variant = item.getAttribute('variant') || false;
              let prd_badge = item.getAttribute('product-badge') || false;
              let prd_badge_tag;

              if (prd_badge) {
                prd_badge_tag = `<span>   </span><span class="badge rounded-0 badge-text">${prd_badge}</span>`;
              } else {
                prd_badge_tag = '';
              }
             
              document.getElementById('productInfoTitle').innerHTML =
                data.title + finalsaletag + prd_badge_tag;
              
              let vendorlink = document.getElementById('prdvendorlink');
              if (vendorlink != null) {
                let artistlink = vendorlink.getAttribute('href');
                console.log(artistlink);
              }
              let artistname = document.getElementById('prdvendor');
              if (artistname != null) {
                console.log(artistname);
              }
              
              //document.getElementById('productVendor')

              let from = '';
              if (data.price_varies) from = 'from ';

              let prdPrice = formatCurrency(+data.price / 100);
              let prdComparePrice = formatCurrency(
                +data.compare_at_price_max / 100
              );

              if (data.compare_at_price_max > 0) {
                let pctDiscount =
                  ((+data.compare_at_price_max / 100 - +data.price / 100) /
                    (+data.compare_at_price_max / 100)) *
                  100;
                //console.log(pctDiscount);
                document.getElementById(
                  'productInfoPrice'
                ).innerHTML = `${pctDiscount.toFixed(
                  0
                )}%<svg class="tag-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" fill="#DF362D" class="bi bi-tag-fill" viewBox="0 0 16 16"><path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/></svg></svg><del><span style="color: #DF362D;">${prdComparePrice}</span></del> ${from}${prdPrice}`;
              } else {
                document.getElementById('productInfoPrice').innerHTML = from + prdPrice;
                  //item.getAttribute('product-price');
              }
              document.getElementById('productInfoDescription').innerHTML =
                productDesc;
              document.getElementById('badge').innerHTML = prdBadge;
              
              let variants = data.variants;
              let variantSelect = document.getElementById('modalItemID');
              variantSelect.innerHTML = '';
              var available = 0;

              variants.forEach(function (variant, index) {
                //console.log(variant);
                //console.log(prd_variant);
                var varPrice = formatCurrency1(variant.price / 100);
                var varOldPrice = formatCurrency1(
                  variant.compare_at_price / 100
                );
                if (variant.available == true) {
                  available++;
                  if (
                    +variant.compare_at_price / 100 > 0 &&
                    +variant.compare_at_price > +variant.price
                  ) {
                    var itemDesc =
                      variant.title +
                      ' (was ' +
                      varOldPrice +
                      ') - now ' +
                      varPrice;
                  } else {
                    var itemDesc = variant.title + ' : ' + varPrice;
                  }

                  let optionItem = new Option(itemDesc, variant.id);

                  if (
                    variants.length == 1 &&
                    variants[0].title == 'Default Title'
                  ) {
                    //console.log('Only variant');

                    variantSelect.options[variantSelect.options.length] =
                      optionItem;
                    optionItem.selected = true;
                    variantSelect.style.display = 'none';
                  } else {
                    //console.log(prd_variant.toString());
                    //console.log(variant.id.toString());
                    if (prd_variant.toString() === variant.id.toString()) {
                      //console.log('Match');

                      variantSelect.options[variantSelect.options.length] =
                        optionItem;

                      optionItem.selected = true;
                      //optionItem.setAttribute('selected', 'selected');
                    } else {
                      variantSelect.options[variantSelect.options.length] =
                        new Option(itemDesc, variant.id);
                    }
                  }
                } else {
                  variantSelect.options[variantSelect.options.length] =
                    new Option(variant.option1, variant.id).setAttribute(
                      'disabled',
                      true
                    );
                }
              });

              if (variants.length > 1) {
                variantSelect.style.display = 'inline';
                //console.log('inline');
              }

              const btnAdd = document.getElementById('btnAddToCart');
              let children = btnAdd.childNodes;
              //console.log(children);
              var text = btnAdd.childNodes[2];                            
              var shoplocale = Shopify.locale;
              //var shop = Shopify;
              //console.log(shop);

              //console.log(shoplocale);
              var btnText1 = shoplocale == 'ja' ? '売り切れ' : 'SOLD OUT';
              var btnText2 =
                shoplocale == 'ja' ? 'カートに追加する' : 'ADD TO CART';
              if (available == 0) {
                btnAdd.disabled = true;
                text.data = btnText1;
                variantSelect.style.display = 'none';
              } else {
                btnAdd.disabled = false;
                text.data = btnText2;
              }
              
               /* Check existing slides & thumbs Slider */
               let slideDiv1 = document.querySelectorAll('#swiperSlides');
                if (slideDiv1.length > 0 ) {
                  slideDiv1.forEach( (item,index) => {
                    //console.log('removing slide ' + index);
                  item.remove();
                  })
                } 

                let thumbDiv1 = document.querySelectorAll('#swiperThumbs');
                if (thumbDiv1.length > 0) {
                  thumbDiv1.forEach( (item,index) => {
                    //console.log('removing thumb ' + index);
                    item.remove();
                  })
                }      

               /* SLIDES */
              let slideReference = document.getElementById('slideReference');
              var swiperSlides =  document.createElement('div');   
              swiperSlides.className = 'swiper-wrapper';
              swiperSlides.id = 'swiperSlides';

              /* THUMBS */
              let thumbReference = document.getElementById('thumbReference');
              var swiperThumbs =  document.createElement('div');   
              swiperThumbs.className = 'swiper-thumbs d-none';
              swiperThumbs.id = 'swiperThumbs';
              swiperThumbs.setAttribute('data-swiper','#quickViewSlider');

              /* get images */
              if (data.images.length > 0 ) {
                let imageSlide='';
                let imageThumb='';
                
                data.images.forEach(function (item, index) {
                  var imgItem = get_img_file(item, 'large');

                  imageSlide += '<div class="swiper-slide" id="imagenum-' + index +'" slidesrc=' + imgItem + '><div class="h-100"><img class="img-prd" src=' + imgItem  + ' alt="' + data.title + '" style="max-height:400px;object-fit:contain;object-position:50% 50%;"></div></div>'; 
                  imageThumb += '<button class="swiper-thumb-item swiper-thumb-item-quickview detail-thumb-item mb-3"><img class="img-fluid" src=' + imgItem + ' alt="' + data.title + '" style="max-height:100px;object-fit:contain;"></button>';
                })
                swiperSlides.innerHTML = imageSlide;
                swiperThumbs.innerHTML = imageThumb;
                slideReference.after(swiperSlides);
                thumbReference.after(swiperThumbs);     

                /* create custom event and dispatch so that the recently created div(s) can be recognized */
                let myEvent = new CustomEvent('dispatchSlide', {
                  bubbles: true,
                  cancelable: true
                  });
    
                setTimeout(()=>{
                    document.dispatchEvent(myEvent);     
                  },2)    
                clearTimeout();               

                /* assign eventlistener to thumbs , must do it here since div was removed when modal closed*/
               
                $(".swiper-thumb-item-quickview").on("click", function (e) {
                  //console.log("clicked");
                  e.preventDefault();
                  var swiperId = $(this).parents(".swiper-thumbs").data("swiper");
                  $(swiperId)[0].swiper.slideToLoop($(this).index());
                });                           
              }
             
              let element = document.getElementById('btnAddToCart');
              element.scrollIntoView(true);
              
            });
        });
      });
            
    } else {
      //console.log('Zero length productInfoAnchors');
    }  
  
}
// END OF prdquickview

function formatCurrency(amount) {
  let ccy = Shopify.currency.active;
  let locale = Shopify.locale;
  //console.log(ccy);
  var ccyTemp = parseFloat(amount).toLocaleString('ja-JP', {
    style: 'currency',
    currency: ccy,
  });
  //remove trailing zeros
  var ccyFormated =
    ccyTemp.slice(-3) === '.00'
      ? ccyTemp.slice(0, -3)
      : ccyTemp.slice(-2) === '.0'
      ? ccyTemp.slice(0, -2)
      : ccyTemp;
  return ccyFormated;
}

function formatCurrency1(amount) {
  var ccyTemp = parseFloat(amount).toLocaleString('ja-JP', {
    style: 'currency',
    currency: 'JPY',
  });

  //remove trailing zeros
  var ccyFormated =
    ccyTemp.slice(-3) === '.00'
      ? ccyTemp.slice(0, -3)
      : ccyTemp.slice(-2) === '.0'
      ? ccyTemp.slice(0, -2)
      : ccyTemp;
  return ccyFormated;
}

function varModalSelectChange(e, data) {
  //in liquid
  //const json_product = {{ product | json }};
  //console.log(json_product);

  //console.log(data);

  const value = e.target.value;
  //const text = SelectElement.options[SelectElement.selectedIndex].text;
  let variantresult = data.variants.find(({ id }) => id === +value);

  if (variantresult) {
    let variant_img_id =
      variantresult.featured_image === null
        ? false
        : variantresult.featured_image.id;

    if (variant_img_id) {
      //console.log(variant_img_id);
      /*document.getElementById('productInfoImg').src =
        variantresult.featured_image.src;
        */
       let imgVariant = get_img_file(variantresult.featured_image.src, 'large');
       //let variantSrc = variantresult.featured_image.src;
       let variantSrc = imgVariant;
        //console.log('variant src :' + variantSrc);

        var testSlide = document.querySelectorAll('[id^="imagenum-"]');
        //var arrtestSlide = Array.from(testSlide);
        //console.log('All imagenum ');
        //console.log(arrtestSlide);

        testSlide.forEach(item => {
          //console.log(item);
          //console.log(item.id);

          const slideID = document.getElementById(item.id);
          
          if (slideID != null) {
            //console.log(`Found`);
            //console.log(slideID);
        
            var slideInfoAnchors = document.querySelectorAll(`#${item.id}`);
        
            if (slideInfoAnchors.length > 0) {
              //console.log(slideInfoAnchors);
              slideInfoAnchors.forEach( item => {
                
                let slideSrc = item.getAttribute('slidesrc');
                //console.log('slide : ' + slideSrc);
  
                if (variantSrc.toString() == 'https:'+slideSrc) {
                  //let slideIdx = item.getAttribute('data-swiper-slide-index');
                  //console.log(slideIdx);
                  
                  let slideLabel = slideID.getAttribute('aria-label');
                  //console.log(slideLabel); 
                  if ( slideLabel ) {
                    let slideIdxArr = slideLabel.split(' / ');            
                    var slideIdx = +slideIdxArr[0];
                    //console.log(slideIdx);
                    //loop false
                    slideIdx -= 1;
                  }
                                          
                  if (quickViewSlider) {
                    //console.log(quickViewSlider);                    
                    //loop true
                    //slideIdx = +slideIdx + 1;
                    //console.log("goto slide :"+slideIdx);

                    quickViewSlider.slideTo(slideIdx, 2000, false);         
                    quickViewSlider.update();
                    highlightThumbquick1(quickViewSlider);
                  }
                }
              }
              )            
            }
          }
        });
    }

    if (value) {
      //console.log(variantresult);

      const curr_price = +variantresult.price / 100;
      const variantPrice = formatCurrency(+variantresult.price / 100);
      const compare_price = +variantresult.compare_at_price / 100;
      const variantComparePrice = formatCurrency(
        +variantresult.compare_at_price / 100
      );
      const savings = (
        ((compare_price - curr_price) / compare_price) *
        100
      ).toFixed(0);

      if (
        +variantresult.compare_at_price > 0 &&
        +variantresult.compare_at_price > +variantresult.price
      ) {
        var pricetag = `${savings}% <svg class="tag-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" fill="#DF362D" class="bi bi-tag-fill" viewBox="0 0 16 16"><path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/></svg></svg>
      <del><span style="color: #AB0000;">${variantComparePrice}</span></del> ${variantPrice}`;
      } else {
        var pricetag = `${variantPrice}`;
      }

      document.getElementById('productInfoPrice').innerHTML = pricetag;
    }
  }
}

function getSlideDataIndex(swipe){
  var activeIndex = swipe.activeIndex;
  var slidesLen = swipe.slides.length;
  if(swipe.params.loop){
      switch(swipe.activeIndex){
          case 0:
              activeIndex = slidesLen-3;
              break;
          case slidesLen-1:
              activeIndex = 0;
              break;
          default:
              --activeIndex;
      }
  }
  return  activeIndex;
}

function bumpCart() {
  let carticon = document.getElementById('cart-icon') || false;
  let carticonMobile = document.getElementById('cart-icon-mobile') || false;
  
  if (carticon) {
    carticon.classList.add('bump');
  }

  setTimeout(() => {
    carticon.classList.remove('bump');
  }, 4000);

  clearTimeout();

  if (carticonMobile) {
    carticonMobile.classList.add('bump');
  }
  
  setTimeout(() => {
    carticonMobile.classList.remove('bump');
  }, 4000);

  clearTimeout();
}

async function update_cart() {
  //console.log(window.Shopify.routes.root);
  await fetch(window.Shopify.routes.root +'cart.js')
    .then(resp => resp.json())
    .then(data => {
      //console.log(data);
      var numberofItems = document.getElementById('numberOfCartItems') || false;
      var numberofItemsMobile = document.getElementById('numberOfCartItemsMobile') || false;

      if (numberofItems) {
        numberofItems.innerHTML = data.item_count;
        numberofItemsMobile.innerHTML = data.item_count;

        if (data.item_count > 0) {
          numberofItems.classList.remove('bg-none');
          numberofItemsMobile.classList.remove('bg-none');
          //numberofItems.classList.add('bg-dark');
          numberofItems.classList.remove('d-none');
          numberofItemsMobile.classList.remove('d-none');
        } else {
          numberofItems.classList.add('bg-none');
          numberofItemsMobile.classList.add('bg-none');
          //numberofItems.classList.remove('bg-dark');
          numberofItems.classList.add('d-none');
          numberofItemsMobile.classList.add('d-none');
        }
      }
    })
    .catch(err => console.log(err));
}

function reset_cart() {
  const sideCardReset = document.getElementById('sideCartData') || false;
  const sideCardSubTotalReset = document.getElementById('sideCardSubTotal') || false;
  if (sideCardReset) { 
    //console.log("initializing");
     sideCardReset.innerHTML = '';
  }

  if (sideCardSubTotalReset) { 
    sideCardSubTotal.innerHTML = '';
  }
}

function get_img_file(imgUrl,size) {
  const imgFileUrl = imgUrl.split('?'); 
  //console.log(imgFileUrl);
  const fileNoExt = imgFileUrl[0].slice(0, +imgFileUrl[0].length - 4);
  const filExt = imgFileUrl[0].slice(-4);
  var prdImgUrl = fileNoExt + '_' + size + filExt +  '?' + imgFileUrl[1];
  //console.log(prdImgUrl);
  return prdImgUrl; 
}

function render_cart() {
  let spinner = document.getElementById('cart-load') || false;
  if (spinner != null) {
    if (spinner.classList.contains('d-none')) {
      spinner.classList.remove('d-none');
    }
  }
  
  let sideCard = document.getElementById('sideCartData') || false;
  let sideCardEmpty = document.getElementById('sideCartDataEmpty') || false;
  let sideCardSubTotal = document.getElementById('sideCardSubTotal') || false;

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(resp => resp.json())
    .then(data => {
      
      //console.log(data);
      
      if (sideCard) {
        //console.log('elem found');

        if (data.items.length > 0) {
          if (sideCard.classList.contains('d-none')) {
            sideCard.classList.remove('d-none');
            sideCardEmpty.classList.add('d-none');
          }

          var cardData = ``;
          data.items.forEach(function (item) {
            //console.log(item);
            let itemPrice = formatCurrency(+item.final_line_price / 100);
            let lineId = item.id;
            if (item.line) {
              let lineItem = item.line;
            }
            
            var imgUrl = item.featured_image.url.split('?'); 
            //console.log(imgUrl);
            var file1 = imgUrl[0].slice(0, +imgUrl[0].length - 4);
            var filExt = imgUrl[0].slice(-4);
            var prdImgUrl = file1 + '_200x200' + filExt +  '?' + imgUrl[1];
            //console.log(prdImgUrl);

            cardData +=
              `<div class="navbar-cart-product" id="${lineId}"> 
                <div class="d-flex align-items-center"><a href="${shopUrl + item.url}"><img class="img-fluid navbar-cart-product-image" fetchpriority="high" src="${prdImgUrl}" alt="${item.product_title}"/></a>
                  <div class="w-100"><a class="navbar-cart-product-remove" href="#!" onclick="removeItemById('${lineId}');">
                      <svg class="svg-icon sidebar-cart-icon">
                        <use xlink:href="#close-1"> </use>
                      </svg></a>
                    <div class="ps-3"> <a class="navbar-cart-product-link text-dark link-animated" href="${shopUrl + item.url}">${item.product_title}</a><small class="d-block text-muted">Quantity: ${item.quantity}</small><strong class="d-block text-sm">${itemPrice}</strong></div>
                  </div>
                </div>
              </div>`;
          })
          sideCard.innerHTML = cardData;
                        
        } else {
          //console.log(data.items.length);
          sideCard.classList.add('d-none');
          sideCardEmpty.classList.remove('d-none');
        }
      }

       if (sideCardSubTotal) {
        let subTotal = formatCurrency(+data.items_subtotal_price / 100);
         var subTotalData = `
        <div class="w-100">
              <p class="text-header text-header-5">Subtotal: <span class="float-right">${subTotal}</span></p>
              <p class="text-sm">${data.item_count} items</p>
              <div class="d-grid gap-3"><a class="btn btn-dark" href="${window.Shopify.routes.root + 'cart'}">カートを見る</a>`;
         
         if (data.item_count > 0) {
         subTotalData += `<a class="btn btn-dark" href="${window.Shopify.routes.root + 'checkout'}">ご購入手続きへ</a>`;  
         }
         
         subTotalData += 
              `</div>
            </div>`;
        sideCardSubTotal.innerHTML = subTotalData;
       }
      if (spinner != null) {
        if (spinner.classList.contains('d-none')) { 
          //do nothing
        } else {
          spinner.classList.add('d-none');
        }
      }
    })
    .catch(err => console.log(err));
}

function close_prdview() {
  const myModalContainer = document.getElementById('quickView');
  const myModal = bootstrap.Modal.getOrCreateInstance(myModalContainer);
  if (myModal) {
    myModal.hide();
  }  
}

function open_drawer() {
  const myModalContainer = document.getElementById('sidebarCart');
  //const myModal = new bootstrap.Modal(myModalContainer);
  const myModal = bootstrap.Modal.getOrCreateInstance(myModalContainer);
  if (myModal) {
    myModal.show();
  }
  
}
      
async function re_rendercart(id) {

  let re_sideCard = document.getElementById('sideCartData') || false;
  let re_sideCardEmpty = document.getElementById('sideCartDataEmpty') || false;
  let re_sideCardSubTotal = document.getElementById('sideCardSubTotal') || false;
  const shoplocale = Shopify.locale; 
    
  await fetch(window.Shopify.routes.root + 'cart.js')
    .then(resp => resp.json())
    .then(data => {
      //console.log("rerender cart");
      //console.log(data);
      
      if (re_sideCard) {

        if (data.items.length > 0) {
          if (re_sideCard.classList.contains('d-none')) {
            re_sideCard.classList.remove('d-none');
            re_sideCardEmpty.classList.add('d-none');
          }

          var arrItems = Array.from(data.items);
          //console.log(arrItems);
          const found = arrItems.some(el => el.id === +id);
          if (!found) {            
              let removeItem = document.getElementById(id);
              if (removeItem) {
                removeItem.remove();
              }
          }

          
        } else {
          //console.log(data.items.length);
          re_sideCard.classList.add('d-none');
          re_sideCardEmpty.classList.remove('d-none');
        }
      }

      if (re_sideCardSubTotal) {
        //console.log("subtotal");
        re_sideCardSubTotal.innerHTML = '';
        let re_subTotal = formatCurrency(+data.items_subtotal_price / 100);
        var re_subTotalData = `
        <div class="w-100">
              <p class="text-header text-header-5">Subtotal: <span class="float-right">${re_subTotal}</span></p>
              <p class="text-sm">${data.item_count} items</p>
              <div class="d-grid gap-3"><a class="btn btn-dark" href="${window.Shopify.routes.root + 'cart'}">カートを見る</a>`;           
        
        if (data.item_count > 0) {
         re_subTotalData += `<a class="btn btn-dark" href="${window.Shopify.routes.root + 'checkout'}">ご購入手続きへ</a>`;  
         }
         
         re_subTotalData += 
              `</div>
            </div>`;
        re_sideCardSubTotal.innerHTML = re_subTotalData;
      }
      update_cart();
    })
    .catch(err => console.log(err));
}


async function getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}
// Example
// const cart = await getCart();

async function removeItem(data) {

  let spinner = document.getElementById('cart-load') || false;
  if (spinner != null) {
    if (spinner.classList.contains('d-none')) {
      spinner.classList.remove('d-none');
    }
  }
  
  const result = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      ...data,
      quantity: 0
    })
  });
  
  const returnResult = result.json();
  //console.log(returnResult);
  //console.log(data);
  re_rendercart(data.id);

  if (spinner != null) {
        if (spinner.classList.contains('d-none')) { 
          //do nothing
        } else {
          spinner.classList.add('d-none');
        }
  }
  return returnResult;
  //return result.json() 
}

async function updateItem(data) {
    const result = await fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
      },
        
        body: JSON.stringify({
            ...data          
        })
    });
  
  const returnResult = result.json();
  //console.log(returnResult);
  //console.log(data);
  re_rendercart(data.id);
  return returnResult;
  //return result.json()
  
}

function removeItemById(id) {
  return removeItem({ id: id });
}

function removeItemByLine(oneBasedLineIndex) {
    return removeItem({ line: oneBasedLineIndex });
}

//MODAL ADD TO CART
const modalAddToCartForm = document.querySelector('#addToCartForm');
//console.log(modalAddToCartForm);

if (modalAddToCartForm != null ) {    
  modalAddToCartForm.addEventListener('submit', function (e) {
    e.preventDefault();
    //console.log('ITEM ID ' + document.getElementById('modalItemID').value);
    //console.log('Value ' + document.getElementById('modalItemQuantity').value);
    let formData = {
      items: [
        {
          id: document.getElementById('modalItemID').value,
          quantity: document.getElementById('modalItemQuantity').value,
        },
      ],
    };
    //console.log(formData);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(resp => resp.json())
      .then(function (data) {
        //console.log(data);

        if (data.status == 422) {
          console.log('Cannot Add this Product : ' + data.description);
          close_prdview();
          AddtoCartErr();
          
        } else {
          //console.log(data);
          //close_prdview();
          //AddtoCartSuccess(data.items[0].product_title);
          close_prdview();
          bumpCart();
          open_drawer();
        }
      })
      .catch(err => {
        console.log('Error:' + err);
        close_prdview();
        AddtoCartErr();
      })
      .then(() => {
        // close_prdview();
      })
      .finally(function () {
        update_cart();
      });
  });
}

//prdcard quick add
function addCartItem(id) {
    
  //console.log(id);
 
    let formData = {
      items: [
        {
          id: id,
          quantity: +1,
        },
      ],
    };
    //console.log(formData);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(resp => resp.json())
      .then(function (data) {
        //console.log(data);

        if (data.status == 422) {
          console.log('Cannot Add this Product : ' + data.description);
          close_prdview();
          throw AddtoCartErr();
        } else {
          //console.log(data);
          //productModal.hide();
          //AddtoCartSuccess(data.items[0].product_title);
          close_prdview();
          bumpCart();
          open_drawer();
        }
      })
      .catch(err => {
        //console.log('Error:' + err);
        close_prdview();
        AddtoCartErr();
      })
      .then(() => {
        // close_prdview();
      })
      .finally(function () {
        update_cart();
      });
}


// for ADD TO CART in Prd Templ
const fmAddToCart = document.querySelector('#addToCartFormTmpl');

if (fmAddToCart != null) {
  const shoplocale = Shopify.locale;
  //console.log(shoplocale);
  //console.log(modalAddToCartForm);
  fmAddToCart.addEventListener('submit', function (e) {
    e.preventDefault();
    //console.log('ITEM ID ' + document.getElementById('productSelect').value);
    //console.log('Value ' + document.getElementById('fmItemQuantity').value);
    let formOrderData = {
      items: [
        {
          id: document.getElementById('productSelect').value,
          quantity: document.getElementById('fmItemQuantity').value,
        },
      ],
    };
    //console.log(formData);
    //console.log(window.Shopify.routes.root);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formOrderData),
    })
      .then(fmresp => fmresp.json())
      .then(function (fmdata) {
        //console.log(fmdata);

        if (fmdata.status == 422) {
          console.log('Cannot Add this Product : ' + fmdata.description);
          throw AddtoCartErr();
        } else {
         //console.log(fmdata);
         //AddtoCartSuccess(data.items[0].product_title);
          bumpCart();
          open_drawer();
        }
      })
      .catch(err => {
        console.log('Error:' + err);
        AddtoCartErr();
      })
      .then(() => {})
      .finally(function () {
        update_cart();
        //console.log("done add to cart");
      });
  });
}

const AddtoCartErr = function (s=5) {
  //productModal.hide();
  setTimeout(() => {
    backToTop();
  }, s);

  const toastEl = toastErr();
  document.body.appendChild(toastEl);
  const myToast = new Toast(toastEl);
  myToast.show();
};

const AddtoCartSuccess = function (item) {
  //productModal.hide();
  setTimeout(() => {
    backToTop();
  }, 5);
  const toastEl = toastSuccess(item);
  document.body.appendChild(toastEl);
  const myToast = new Toast(toastEl);
  myToast.show();
};

const { Toast } = bootstrap;

const htmlMarkup = `
  <div aria-atomic="true" aria-live="assertive" class="toast position-absolute end-0 top-0 m-3 bg-light border-0" style="z-index: 9999;" role="alert" id="myAlert">
      <div class="toast-header text-white bg-success">
            <h6 class="me-auto">Success</h6>            
      </div>`;

const htmlMarkupErr = `
  <div aria-atomic="true" aria-live="assertive" class="toast position-absolute end-0 top-0 m-3 bg-light border-0" style="z-index: 9999;" role="alert" id="myAlertErr">
      <div class="toast-header text-white bg-danger">
            <h6 class="me-auto">注意事項</h6>            
      </div>
      <div class="toast-body text-sm">
          <p>商品がカートに追加されませんでした。すでにカートの中に入っているかどうか確認してください。</p>
      </div>
  </div>
`;

function toastSuccess(item) {
  var template = document.createElement('template');
  var html = htmlMarkup.trim();
  html += `
  <div class="toast-body">
  <strong>${item}</strong> : added to Cart
  </div>
  </div>`;
  template.innerHTML = html;
  return template.content.firstChild;
}

// results returns no item data if error, no need parameter
function toastErr() {
  var templateErr = document.createElement('template');
  var html = htmlMarkupErr.trim();
  templateErr.innerHTML = html;
  return templateErr.content.firstChild;
}

/* wishlist lazy load */
const configWish = {
        root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
        rootMargin: '0px',
        threshold: 0
      };
      const observerWish = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(entry)
        if (entry.isIntersecting === true) {
            const img = entry.target.querySelector("img");
            const src = img.getAttribute("data-src");
            entry.target.classList.add("inview");
            img.setAttribute("src", src);
            observerWish.unobserve(entry.target);
          } else {
            entry.target.classList.remove("inview");
        }
      });
    },configWish);
    const itemsWish = document.querySelectorAll(".grid-product-wish");
    
    itemsWish.forEach((item, index) => {
      observer.observe(item, index);
    });
  
function submitFormWish(fmName,id) {
    const formCard = document.getElementById(fmName);
    //console.log(formCard);
    if (formCard) {
        addCartItem(id);
    }
}

